
<template>
  <div>
    <Show />
  </div>
</template>

<script>
import Show from './Show'
export default {
  components: {
    Show
  },
  props: {},
  data() {
    return {
      title: '科研团队组织架构'
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

